import { render, staticRenderFns } from "./OurNews.vue?vue&type=template&id=c074107c&scoped=true&"
import script from "./OurNews.vue?vue&type=script&lang=js&"
export * from "./OurNews.vue?vue&type=script&lang=js&"
import style0 from "./OurNews.vue?vue&type=style&index=0&id=c074107c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c074107c",
  null
  
)

export default component.exports